import { useEffect, useMemo, useRef, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useUserContext } from '../../contexts/UserContext';
import { useMembersV4 } from '../../hooks/useMembers';
import {
  addUpdateParamsInSequence,
  filterSelector,
  removeParamsInSequence,
  resetMembers,
  setMembers,
} from '../../redux/slicers/filters/filterSlicer';
import { selectTeamMembersFilterOpen, setRightOffcanvasOpen } from '../../redux/slicers/uiSlicer';
import UserGroupIcon from '../icons/UserGroupIcon';
import UserIcon from '../icons/UserIcon';
import { MemberOverlay } from '../MemberOverlay';
import { MemberOverlaySharedBy } from '../MemberOverlaySharedBy';

export const TeamMembersFilter = ({ iconOnly = false, defaultSelected = '', disabled = false , teamFilterModal= null }) => {
  const dispatch = useDispatch();
  const show = useSelector(selectTeamMembersFilterOpen);
  const [keepMounted, setKeepMounted] = useState(false);
  // let teamSelected = useSelector(anyMemberSelected);
  const selectedMembers = useSelector((state) => filterSelector(state).members);
  // const { currentUser } = useUserContext();
  // const meSelected = selectedMembers.length === 1 && selectedMembers[0].id === currentUser.id;

  let teamSelected = false; // !meSelected;

  const handleClose = () => {
    dispatch(setRightOffcanvasOpen(false));
  };
  // const handleShow = () => {
  //   setKeepMounted(true);
  //   dispatch(setRightOffcanvasOpen(true));
  // };

  // const handleMeClick = () => {
  //   if (meSelected) {
  //     dispatch(resetMembers());
  //     dispatch(removeParamsInSequence('created_by'));
  //   } else {
  //     dispatch(
  //       setMembers([
  //         {
  //           name: currentUser.name,
  //           id: currentUser.id,
  //           avatar: currentUser.profile_image,
  //         },
  //       ])
  //     );
  //   }

  //   dispatch(setRightOffcanvasOpen(false));
  // };

  const handleChange = (memberIds) => {
    dispatch(setMembers(memberIds));
  };

  return (
    <>
      {(show || keepMounted || teamFilterModal) && (
        <TeamMembersFilterOverlayController
          show={show || teamFilterModal}
          onClose={handleClose}
          onChange={handleChange}
          selectedMembers={selectedMembers}
        />
      )}
    </>
  );
};

const TeamMembersFilterOverlayController = (props) => {
  const { currentUser } = useUserContext();

  const requestParams =  useMemo(() => ({
    perPage: 50
  }), [])

  const {
    list: memberList,
    loading,
    hasMore,
    search,
    dataLoadedOnce,
    onSearchChange,
    loadAllPages,
  } = useMembersV4({
    requestParams
  });

  // const listWithCurrentUserAsFirst = memberList;
  const listWithCurrentUserAsFirst = memberList.filter((m) => m.id !== currentUser.id);
  listWithCurrentUserAsFirst.unshift(currentUser);

  useEffect(() => {
    if (dataLoadedOnce) {
      loadAllPages();
    }
  }, [dataLoadedOnce]);

  const sections = [
    {
      noItemsText: 'No user found!',
      fetchMoreData: () => {},
      loading,
      name: 'INSIDE_MEMBERS',
      hasMore,
      items: listWithCurrentUserAsFirst.map((member) => {
        let name = member.user.name;

        if (!name || !name.trim()) {
          name = member.user.first_name
            ? `${member.user.first_name} ${member.user.last_name || ''}`
            : member.user.email;
        }

        return {
          id: member.id,
          name: name,
          avatar: member.user.profile_image,
        };
      }),
    },
  ];

  return (
    <TeamMembersFilterOverlayUI
      {...props}
      sections={sections}
      search={search}
      onSearchChange={onSearchChange}
    />
  );
};

export const TeamMembersFilterOverlayUI = ({
  onClose,
  show,
  onChange,
  selectedMembers,
  sections,
  search,
  onSearchChange,
  ...props
}) => {
  const handleSelectAll = () => {
    // console.log("sections: ", sections)

    const items = [];
    sections.map((a) => items.push(...a.items)); //[...sections[0].items, ...sections[1].items]
    // const allIds = section.items.map((member) => member.id);
    const allIds = items.map((member) => member.id);
    const selectedIds = selectedMembers.map((m) => m.id);
    const allSelected = allIds.every((id) => selectedIds.includes(id));

    const newValue = allSelected ? [] : items; // section.items;
    onChange(newValue);
  };

  const handleSelect = (member) => {
    const newValue = selectedMembers.find((m) => m.id === member.id)
      ? selectedMembers.filter((m) => m.id !== member.id)
      : [...selectedMembers, member];

    onChange(newValue);
  };

  return props?.insideOverLay ? (
    <MemberOverlaySharedBy
      sections={sections}
      onSelectAll={handleSelectAll}
      onSelect={handleSelect}
      selected={selectedMembers}
      search={search}
      onSearchChange={onSearchChange}
      show={show}
      onClose={onClose}
      onChange={onChange}
      designV2
    />
  ) : (
    <MemberOverlay
      sections={sections}
      onSelectAll={handleSelectAll}
      onSelect={handleSelect}
      selected={selectedMembers}
      search={search}
      onSearchChange={onSearchChange}
      show={show}
      onClose={onClose}
      onChange={onChange}
      designV2
    />
  );
};
